module.exports = __webpack_public_path__ + "img/fbot_512x512.4fa7777e.png";